import React from "react";

type ImageMarqueeProps = {
  photos: string[];
  reverse?: boolean;
};

// Continuous, seamless horizontal photo band ("behind the scenes").
// The track holds the photos twice and translates by -50%, so the loop is
// gapless. Purely decorative — hidden from assistive tech.
function ImageMarquee({ photos, reverse = false }: ImageMarqueeProps) {
  const loop = [...photos, ...photos];

  return (
    <div className="marquee" aria-hidden="true">
      <div className={`marquee-track ${reverse ? "is-reverse" : ""}`}>
        {loop.map((src, index) => (
          <div className="marquee-item" key={index}>
            <img src={src} alt="" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ImageMarquee;
